import { render, staticRenderFns } from "./LffFooter.vue?vue&type=template&id=bd6d7b66&scoped=true&"
import script from "./LffFooter.vue?vue&type=script&lang=js&"
export * from "./LffFooter.vue?vue&type=script&lang=js&"
import style0 from "./LffFooter.vue?vue&type=style&index=0&id=bd6d7b66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6d7b66",
  null
  
)

export default component.exports